import { RESOURCES } from './constants';

/**
 * Validates if a resource exists in the RESOURCES object
 * @param {string} resource - The resource to validate (can be either key or value)
 * @returns {boolean} - True if resource exists, false otherwise
 */
export const validateResource = (resource) => {
  if (!resource) {
    console.error('Resource parameter is required');
    return false;
  }

  let isValid = false;

  if (typeof resource === 'object' && 'name' in resource) {
    isValid = true;
  }

  if (isValid) return true;

  // Check if resource exists as a key in RESOURCES
  const exists = Object.keys(RESOURCES).find((key) => {
    return RESOURCES[key].name == resource;
  });

  return !!exists;
};

/**
 * Compute the singular form of the resource name if none provided
 */
export const computedResourceSingular = (resource) => {
  // Handle special cases first
  if (resource.label === 'Business') {
    return 'Business'; // Keep as is, don't remove 's'
  }
  
  // Simple logic to convert plural to singular (not comprehensive)
  if (resource.label.endsWith('ies')) {
    return resource.label.slice(0, -3) + 'y';
  } else if (resource.label.endsWith('s')) {
    // Don't remove 's' for words that are already singular
    const singularWords = ['Business', 'Status', 'Address', 'Process'];
    if (singularWords.includes(resource.label)) {
      return resource.label;
    }
    return resource.label.slice(0, -1);
  }
  return resource.label;
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
};

export const generateRandomString = (length = 10) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  return result;
};

// Debounce utility
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
